import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import EdaTableService from '../service/EdaTableService';
import EdaTableViewButton from '../component/EdaTableViewButton';
import EdaTableDownloadButton from '../component/EdaTableDownloadButton';

const config = {
	key: 'edaTable',
	topic: 'eda',
	text: 'EDA',
	service: EdaTableService,
	toolbarAction: ['filter', 'search', 'refresh'],
	rowButtonList: [
		{ key: 'viewButton', component: EdaTableViewButton },
		{ key: 'downloadButton', component: EdaTableDownloadButton }
	],
	rowAction: ['delete'],
	toolbarSearchFieldKey: 'measurementList.name',
	filterFields: [
		{
			propertyName: 'created',
			text: 'Created',
			propertyType: 'Date',
			type: 'INTERVAL'
		},
		{
			propertyName: 'updated',
			text: 'Updated',
			propertyType: 'Date',
			type: 'INTERVAL'
		}
	],
	columns: [
		{
			key: 'measurementListText',
			text: 'Measurement',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'deviceListText',
			text: 'Device',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'edaTypeListText',
			text: 'Type of analysis',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'status',
			text: 'Status',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'infrastructureElementListText',
			text: 'Infrastructure Element',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
        {
			key: 'measurementCreatedListText',
			text: 'Measurement Created',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'created',
			text: 'Created',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'updated',
			text: 'Updated',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		}
	]
};

function EdaTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('edaTable', reducer('edaTable'))(EdaTable);
